import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-order-reco-card',
  templateUrl: './order-reco-card.component.html',
  styleUrls: ['./order-reco-card.component.scss']
})
export class OrderRecoCardComponent implements OnInit {
  @Input() config;


  constructor(
  ) { }

  ngOnInit(): void {
  }
}
